import { Text } from '../core/atoms/Text';
import { Group } from '../core/atoms/Group';

export interface BrandLogoProps {
  /** Override logo URL (tenant theme). Defaults to /brand/logo-sm.svg */
  logoUrl?: string | null;
  /** Show wordmark next to mark */
  withWordmark?: boolean;
  wordmark?: string;
  size?: number;
  inverted?: boolean;
}

export function BrandLogo({
  logoUrl,
  withWordmark = true,
  wordmark = 'VIPSo',
  size = 36,
  inverted = false,
}: BrandLogoProps) {
  const src = logoUrl || (inverted ? '/brand/logo-white.svg' : '/brand/logo-sm.svg');

  return (
    <Group gap="sm" wrap="nowrap" align="center">
      <img
        src={src}
        alt={wordmark}
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
          display: 'block',
          flexShrink: 0,
        }}
      />
      {withWordmark ? (
        <Text
          fw={700}
          style={{
            fontSize: size >= 36 ? 20 : 16,
            letterSpacing: '-0.02em',
            color: inverted ? '#fff' : 'var(--mantine-color-navy-9)',
            lineHeight: 1,
          }}
        >
          {wordmark}
        </Text>
      ) : null}
    </Group>
  );
}
